import * as React from 'react'
import { SVGProps } from 'react'

const SvgSpeedMechanics = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    viewBox='0 0 400.667 400.666'
    xmlSpace='preserve'
    {...props}
  >
    <circle fill='#232323' cx={200.333} cy={200} r={161} />
    <path
      fill='none'
      stroke='#F9FF00'
      strokeWidth={10}
      strokeMiterlimit={10}
      d='M57.4 175.086C43.974 251.226 91.471 314.98 149.825 336'
    />
    <path
      fill='none'
      stroke='red'
      strokeWidth={10}
      strokeMiterlimit={10}
      d='M106.854 89.039c-28.113 23.588-44.001 55.344-49.512 86.375'
    />
    <path
      fill='none'
      stroke='#007511'
      strokeWidth={10}
      strokeMiterlimit={10}
      d='M151.628 336.661c40.369 14.45 85.524 10.282 121.509-10.494 62.801-36.257 97.126-122.438 53.195-198.528'
    />
    <path
      fill='none'
      stroke='#FFF'
      strokeWidth={4}
      strokeMiterlimit={10}
      d='m296.814 85.02-15.062 17.948M310.03 136.667l20.291-11.714M348.149 173.938l-23.073 4.068M348.149 226.065l-23.073-4.068M330.32 275.05l-20.29-11.714M296.812 314.982l-15.06-17.947M251.667 341.046l-8.012-22.015M200.331 350.098l.001-23.428M148.995 341.045l8.013-22.015M103.85 314.98l15.061-17.946M70.343 275.047l20.29-11.713M52.515 226.063l23.073-4.068M52.516 173.934l23.072 4.07M70.346 124.949l20.289 11.717M103.854 85.018l15.058 17.949'
    />
    <path
      fill='none'
      stroke='#FFF'
      strokeWidth={2}
      strokeMiterlimit={10}
      d='m315.313 103.523-12.238 10.274'
    />
    <path
      fill='none'
      stroke='#FFF'
      strokeWidth={4}
      strokeMiterlimit={10}
      d='m251.669 58.956-8.014 22.017'
    />
    <path
      fill='none'
      stroke='#FFF'
      strokeWidth={2}
      strokeMiterlimit={10}
      d='m275.381 70.017-7.986 13.838'
    />
    <path
      fill='none'
      stroke='#FFF'
      strokeWidth={4}
      strokeMiterlimit={10}
      d='M200.333 49.904v23.43'
    />
    <path
      fill='none'
      stroke='#FFF'
      strokeWidth={2}
      strokeMiterlimit={10}
      d='m226.398 52.188-2.772 15.735M213.417 50.478l-.973 11.141M239.182 55.021l-2.893 10.803M263.767 63.969l-4.725 10.136M286.424 77.05l-6.414 9.162M341.376 148.667l-15.014 5.469M350.427 200.002l-15.979.004M341.375 251.337l-15.017-5.461M315.312 296.48l-12.245-10.267M275.38 329.987l-7.995-13.837M226.396 347.816l-2.781-15.737M174.268 347.816l2.77-15.739M125.284 329.988l7.986-13.843M85.351 296.481l12.239-10.278M59.287 251.337l15.016-5.473M50.235 200l15.982-.006M59.287 148.664l15.02 5.461M85.351 103.52l12.247 10.268'
    />
    <text
      transform='translate(257.66 123.649)'
      fill='#FFF'
      stroke='#FFF'
      strokeWidth={0.5}
      strokeMiterlimit={10}
      fontFamily='sans-serif'
      fontSize={20}
    >
      {'20'}
    </text>
    <text
      transform='translate(292.16 187.149)'
      fill='#FFF'
      stroke='#FFF'
      strokeWidth={0.5}
      strokeMiterlimit={10}
      fontFamily='sans-serif'
      fontSize={20}
    >
      {'40'}
    </text>
    <text
      transform='translate(267.385 263.336)'
      fill='#FFF'
      stroke='#FFF'
      strokeWidth={0.5}
      strokeMiterlimit={10}
      fontFamily='sans-serif'
      fontSize={20}
    >
      {'60'}
    </text>
    <text
      transform='translate(225.006 302.149)'
      fill='#FFF'
      stroke='#FFF'
      strokeWidth={0.5}
      strokeMiterlimit={10}
      fontFamily='sans-serif'
      fontSize={20}
    >
      {'80'}
    </text>
    <text
      transform='translate(153.001 302.149)'
      fill='#FFF'
      stroke='#FFF'
      strokeWidth={0.5}
      strokeMiterlimit={10}
      fontFamily='sans-serif'
      fontSize={20}
    >
      {'100'}
    </text>
    <text
      transform='translate(107.16 256.649)'
      fill='#FFF'
      stroke='#FFF'
      strokeWidth={0.5}
      strokeMiterlimit={10}
      fontFamily='sans-serif'
      fontSize={20}
    >
      {'120'}
    </text>
    <text
      transform='translate(91.475 184.649)'
      fill='#FFF'
      stroke='#FFF'
      strokeWidth={0.5}
      strokeMiterlimit={10}
      fontFamily='sans-serif'
      fontSize={20}
    >
      {'140'}
    </text>
    <text
      transform='translate(125.284 123.649)'
      fill='#FFF'
      stroke='#FFF'
      strokeWidth={0.5}
      strokeMiterlimit={10}
      fontFamily='sans-serif'
      fontSize={20}
    >
      {'160'}
    </text>
    <text
      transform='translate(175.38 242.19)'
      fill='#FFF'
      stroke='#FFF'
      strokeWidth={0.5}
      strokeMiterlimit={10}
      fontFamily='sans-serif'
      fontSize={14}
    >
      {'KNOTS'}
    </text>
    <text
      transform='translate(161.309 165.19)'
      fill='#FFF'
      stroke='#FFF'
      strokeWidth={0.5}
      strokeMiterlimit={10}
      fontFamily='sans-serif'
      fontSize={14}
    >
      {'AIR SPEED'}
    </text>
    <text
      transform='translate(194.66 99.649)'
      fill='#FFF'
      stroke='#FFF'
      strokeWidth={0.5}
      strokeMiterlimit={10}
      fontFamily='sans-serif'
      fontSize={20}
    >
      {'0'}
    </text>
  </svg>
)

export default SvgSpeedMechanics
